/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrainingRouteImport } from './routes/training'
import { Route as TournamentRouteImport } from './routes/tournament'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as FreegameRouteImport } from './routes/freegame'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as R404RouteImport } from './routes/404'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrainingIndexRouteImport } from './routes/training/index'
import { Route as SnapshotsIndexRouteImport } from './routes/snapshots/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as DebugIndexRouteImport } from './routes/debug/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as TrainingCreateRouteImport } from './routes/training/create'
import { Route as SnapshotsIdRouteImport } from './routes/snapshots/$id'
import { Route as DebugSnapshotIdRouteImport } from './routes/debug/$snapshotId'
import { Route as DebugSplatRouteImport } from './routes/debug/$'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as ProtectedToplistRouteImport } from './routes/_protected/toplist'
import { Route as ProtectedTableRouteImport } from './routes/_protected/table'
import { Route as ProtectedTournamentsIndexRouteImport } from './routes/_protected/tournaments/index'
import { Route as ProtectedFreegamesIndexRouteImport } from './routes/_protected/freegames/index'
import { Route as ProtectedAccountIndexRouteImport } from './routes/_protected/account/index'
import { Route as TournamentsIdJoinRouteImport } from './routes/tournaments/$id/join'
import { Route as GamesIdSpectateRouteImport } from './routes/games/$id/spectate'
import { Route as GamesIdReplayRouteImport } from './routes/games/$id/replay'
import { Route as GamesIdJoinRouteImport } from './routes/games/$id/join'
import { Route as FreegamesIdSpectateRouteImport } from './routes/freegames/$id/spectate'
import { Route as FreegamesIdJoinRouteImport } from './routes/freegames/$id/join'
import { Route as DebugTrainingSnapshotIdRouteImport } from './routes/debug/training/$snapshotId'
import { Route as DebugNewgameSnapshotIdRouteImport } from './routes/debug/newgame/$snapshotId'
import { Route as ProtectedFreegamesCreateRouteImport } from './routes/_protected/freegames/create'
import { Route as ProtectedAccountSubscriptionsRouteImport } from './routes/_protected/account/subscriptions'

const TrainingRoute = TrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentRoute = TournamentRouteImport.update({
  id: '/tournament',
  path: '/tournament',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const FreegameRoute = FreegameRouteImport.update({
  id: '/freegame',
  path: '/freegame',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingIndexRoute = TrainingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TrainingRoute,
} as any)
const SnapshotsIndexRoute = SnapshotsIndexRouteImport.update({
  id: '/snapshots/',
  path: '/snapshots/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIndexRoute = GamesIndexRouteImport.update({
  id: '/games/',
  path: '/games/',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugIndexRoute = DebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingCreateRoute = TrainingCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => TrainingRoute,
} as any)
const SnapshotsIdRoute = SnapshotsIdRouteImport.update({
  id: '/snapshots/$id',
  path: '/snapshots/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSnapshotIdRoute = DebugSnapshotIdRouteImport.update({
  id: '/debug/$snapshotId',
  path: '/debug/$snapshotId',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugSplatRoute = DebugSplatRouteImport.update({
  id: '/debug/$',
  path: '/debug/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedToplistRoute = ProtectedToplistRouteImport.update({
  id: '/toplist',
  path: '/toplist',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTableRoute = ProtectedTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTournamentsIndexRoute =
  ProtectedTournamentsIndexRouteImport.update({
    id: '/tournaments/',
    path: '/tournaments/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedFreegamesIndexRoute = ProtectedFreegamesIndexRouteImport.update({
  id: '/freegames/',
  path: '/freegames/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAccountIndexRoute = ProtectedAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => ProtectedRoute,
} as any)
const TournamentsIdJoinRoute = TournamentsIdJoinRouteImport.update({
  id: '/tournaments/$id/join',
  path: '/tournaments/$id/join',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdSpectateRoute = GamesIdSpectateRouteImport.update({
  id: '/games/$id/spectate',
  path: '/games/$id/spectate',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdReplayRoute = GamesIdReplayRouteImport.update({
  id: '/games/$id/replay',
  path: '/games/$id/replay',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdJoinRoute = GamesIdJoinRouteImport.update({
  id: '/games/$id/join',
  path: '/games/$id/join',
  getParentRoute: () => rootRouteImport,
} as any)
const FreegamesIdSpectateRoute = FreegamesIdSpectateRouteImport.update({
  id: '/freegames/$id/spectate',
  path: '/freegames/$id/spectate',
  getParentRoute: () => rootRouteImport,
} as any)
const FreegamesIdJoinRoute = FreegamesIdJoinRouteImport.update({
  id: '/freegames/$id/join',
  path: '/freegames/$id/join',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugTrainingSnapshotIdRoute = DebugTrainingSnapshotIdRouteImport.update({
  id: '/debug/training/$snapshotId',
  path: '/debug/training/$snapshotId',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugNewgameSnapshotIdRoute = DebugNewgameSnapshotIdRouteImport.update({
  id: '/debug/newgame/$snapshotId',
  path: '/debug/newgame/$snapshotId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedFreegamesCreateRoute =
  ProtectedFreegamesCreateRouteImport.update({
    id: '/freegames/create',
    path: '/freegames/create',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedAccountSubscriptionsRoute =
  ProtectedAccountSubscriptionsRouteImport.update({
    id: '/account/subscriptions',
    path: '/account/subscriptions',
    getParentRoute: () => ProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/freegame': typeof FreegameRoute
  '/results': typeof ResultsRoute
  '/tournament': typeof TournamentRoute
  '/training': typeof TrainingRouteWithChildren
  '/table': typeof ProtectedTableRoute
  '/toplist': typeof ProtectedToplistRoute
  '/auth/action': typeof AuthActionRoute
  '/debug/$': typeof DebugSplatRoute
  '/debug/$snapshotId': typeof DebugSnapshotIdRoute
  '/snapshots/$id': typeof SnapshotsIdRoute
  '/training/create': typeof TrainingCreateRoute
  '/users/$id': typeof UsersIdRoute
  '/debug/': typeof DebugIndexRoute
  '/games/': typeof GamesIndexRoute
  '/snapshots/': typeof SnapshotsIndexRoute
  '/training/': typeof TrainingIndexRoute
  '/account/subscriptions': typeof ProtectedAccountSubscriptionsRoute
  '/freegames/create': typeof ProtectedFreegamesCreateRoute
  '/debug/newgame/$snapshotId': typeof DebugNewgameSnapshotIdRoute
  '/debug/training/$snapshotId': typeof DebugTrainingSnapshotIdRoute
  '/freegames/$id/join': typeof FreegamesIdJoinRoute
  '/freegames/$id/spectate': typeof FreegamesIdSpectateRoute
  '/games/$id/join': typeof GamesIdJoinRoute
  '/games/$id/replay': typeof GamesIdReplayRoute
  '/games/$id/spectate': typeof GamesIdSpectateRoute
  '/tournaments/$id/join': typeof TournamentsIdJoinRoute
  '/account/': typeof ProtectedAccountIndexRoute
  '/freegames/': typeof ProtectedFreegamesIndexRoute
  '/tournaments/': typeof ProtectedTournamentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/freegame': typeof FreegameRoute
  '/results': typeof ResultsRoute
  '/tournament': typeof TournamentRoute
  '/table': typeof ProtectedTableRoute
  '/toplist': typeof ProtectedToplistRoute
  '/auth/action': typeof AuthActionRoute
  '/debug/$': typeof DebugSplatRoute
  '/debug/$snapshotId': typeof DebugSnapshotIdRoute
  '/snapshots/$id': typeof SnapshotsIdRoute
  '/training/create': typeof TrainingCreateRoute
  '/users/$id': typeof UsersIdRoute
  '/debug': typeof DebugIndexRoute
  '/games': typeof GamesIndexRoute
  '/snapshots': typeof SnapshotsIndexRoute
  '/training': typeof TrainingIndexRoute
  '/account/subscriptions': typeof ProtectedAccountSubscriptionsRoute
  '/freegames/create': typeof ProtectedFreegamesCreateRoute
  '/debug/newgame/$snapshotId': typeof DebugNewgameSnapshotIdRoute
  '/debug/training/$snapshotId': typeof DebugTrainingSnapshotIdRoute
  '/freegames/$id/join': typeof FreegamesIdJoinRoute
  '/freegames/$id/spectate': typeof FreegamesIdSpectateRoute
  '/games/$id/join': typeof GamesIdJoinRoute
  '/games/$id/replay': typeof GamesIdReplayRoute
  '/games/$id/spectate': typeof GamesIdSpectateRoute
  '/tournaments/$id/join': typeof TournamentsIdJoinRoute
  '/account': typeof ProtectedAccountIndexRoute
  '/freegames': typeof ProtectedFreegamesIndexRoute
  '/tournaments': typeof ProtectedTournamentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/_protected': typeof ProtectedRouteWithChildren
  '/freegame': typeof FreegameRoute
  '/results': typeof ResultsRoute
  '/tournament': typeof TournamentRoute
  '/training': typeof TrainingRouteWithChildren
  '/_protected/table': typeof ProtectedTableRoute
  '/_protected/toplist': typeof ProtectedToplistRoute
  '/auth/action': typeof AuthActionRoute
  '/debug/$': typeof DebugSplatRoute
  '/debug/$snapshotId': typeof DebugSnapshotIdRoute
  '/snapshots/$id': typeof SnapshotsIdRoute
  '/training/create': typeof TrainingCreateRoute
  '/users/$id': typeof UsersIdRoute
  '/debug/': typeof DebugIndexRoute
  '/games/': typeof GamesIndexRoute
  '/snapshots/': typeof SnapshotsIndexRoute
  '/training/': typeof TrainingIndexRoute
  '/_protected/account/subscriptions': typeof ProtectedAccountSubscriptionsRoute
  '/_protected/freegames/create': typeof ProtectedFreegamesCreateRoute
  '/debug/newgame/$snapshotId': typeof DebugNewgameSnapshotIdRoute
  '/debug/training/$snapshotId': typeof DebugTrainingSnapshotIdRoute
  '/freegames/$id/join': typeof FreegamesIdJoinRoute
  '/freegames/$id/spectate': typeof FreegamesIdSpectateRoute
  '/games/$id/join': typeof GamesIdJoinRoute
  '/games/$id/replay': typeof GamesIdReplayRoute
  '/games/$id/spectate': typeof GamesIdSpectateRoute
  '/tournaments/$id/join': typeof TournamentsIdJoinRoute
  '/_protected/account/': typeof ProtectedAccountIndexRoute
  '/_protected/freegames/': typeof ProtectedFreegamesIndexRoute
  '/_protected/tournaments/': typeof ProtectedTournamentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/freegame'
    | '/results'
    | '/tournament'
    | '/training'
    | '/table'
    | '/toplist'
    | '/auth/action'
    | '/debug/$'
    | '/debug/$snapshotId'
    | '/snapshots/$id'
    | '/training/create'
    | '/users/$id'
    | '/debug/'
    | '/games/'
    | '/snapshots/'
    | '/training/'
    | '/account/subscriptions'
    | '/freegames/create'
    | '/debug/newgame/$snapshotId'
    | '/debug/training/$snapshotId'
    | '/freegames/$id/join'
    | '/freegames/$id/spectate'
    | '/games/$id/join'
    | '/games/$id/replay'
    | '/games/$id/spectate'
    | '/tournaments/$id/join'
    | '/account/'
    | '/freegames/'
    | '/tournaments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/freegame'
    | '/results'
    | '/tournament'
    | '/table'
    | '/toplist'
    | '/auth/action'
    | '/debug/$'
    | '/debug/$snapshotId'
    | '/snapshots/$id'
    | '/training/create'
    | '/users/$id'
    | '/debug'
    | '/games'
    | '/snapshots'
    | '/training'
    | '/account/subscriptions'
    | '/freegames/create'
    | '/debug/newgame/$snapshotId'
    | '/debug/training/$snapshotId'
    | '/freegames/$id/join'
    | '/freegames/$id/spectate'
    | '/games/$id/join'
    | '/games/$id/replay'
    | '/games/$id/spectate'
    | '/tournaments/$id/join'
    | '/account'
    | '/freegames'
    | '/tournaments'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/_protected'
    | '/freegame'
    | '/results'
    | '/tournament'
    | '/training'
    | '/_protected/table'
    | '/_protected/toplist'
    | '/auth/action'
    | '/debug/$'
    | '/debug/$snapshotId'
    | '/snapshots/$id'
    | '/training/create'
    | '/users/$id'
    | '/debug/'
    | '/games/'
    | '/snapshots/'
    | '/training/'
    | '/_protected/account/subscriptions'
    | '/_protected/freegames/create'
    | '/debug/newgame/$snapshotId'
    | '/debug/training/$snapshotId'
    | '/freegames/$id/join'
    | '/freegames/$id/spectate'
    | '/games/$id/join'
    | '/games/$id/replay'
    | '/games/$id/spectate'
    | '/tournaments/$id/join'
    | '/_protected/account/'
    | '/_protected/freegames/'
    | '/_protected/tournaments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ProtectedRoute: typeof ProtectedRouteWithChildren
  FreegameRoute: typeof FreegameRoute
  ResultsRoute: typeof ResultsRoute
  TournamentRoute: typeof TournamentRoute
  TrainingRoute: typeof TrainingRouteWithChildren
  AuthActionRoute: typeof AuthActionRoute
  DebugSplatRoute: typeof DebugSplatRoute
  DebugSnapshotIdRoute: typeof DebugSnapshotIdRoute
  SnapshotsIdRoute: typeof SnapshotsIdRoute
  UsersIdRoute: typeof UsersIdRoute
  DebugIndexRoute: typeof DebugIndexRoute
  GamesIndexRoute: typeof GamesIndexRoute
  SnapshotsIndexRoute: typeof SnapshotsIndexRoute
  DebugNewgameSnapshotIdRoute: typeof DebugNewgameSnapshotIdRoute
  DebugTrainingSnapshotIdRoute: typeof DebugTrainingSnapshotIdRoute
  FreegamesIdJoinRoute: typeof FreegamesIdJoinRoute
  FreegamesIdSpectateRoute: typeof FreegamesIdSpectateRoute
  GamesIdJoinRoute: typeof GamesIdJoinRoute
  GamesIdReplayRoute: typeof GamesIdReplayRoute
  GamesIdSpectateRoute: typeof GamesIdSpectateRoute
  TournamentsIdJoinRoute: typeof TournamentsIdJoinRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/training': {
      id: '/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof TrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournament': {
      id: '/tournament'
      path: '/tournament'
      fullPath: '/tournament'
      preLoaderRoute: typeof TournamentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freegame': {
      id: '/freegame'
      path: '/freegame'
      fullPath: '/freegame'
      preLoaderRoute: typeof FreegameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training/': {
      id: '/training/'
      path: '/'
      fullPath: '/training/'
      preLoaderRoute: typeof TrainingIndexRouteImport
      parentRoute: typeof TrainingRoute
    }
    '/snapshots/': {
      id: '/snapshots/'
      path: '/snapshots'
      fullPath: '/snapshots/'
      preLoaderRoute: typeof SnapshotsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/': {
      id: '/games/'
      path: '/games'
      fullPath: '/games/'
      preLoaderRoute: typeof GamesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/': {
      id: '/debug/'
      path: '/debug'
      fullPath: '/debug/'
      preLoaderRoute: typeof DebugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training/create': {
      id: '/training/create'
      path: '/create'
      fullPath: '/training/create'
      preLoaderRoute: typeof TrainingCreateRouteImport
      parentRoute: typeof TrainingRoute
    }
    '/snapshots/$id': {
      id: '/snapshots/$id'
      path: '/snapshots/$id'
      fullPath: '/snapshots/$id'
      preLoaderRoute: typeof SnapshotsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/$snapshotId': {
      id: '/debug/$snapshotId'
      path: '/debug/$snapshotId'
      fullPath: '/debug/$snapshotId'
      preLoaderRoute: typeof DebugSnapshotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/$': {
      id: '/debug/$'
      path: '/debug/$'
      fullPath: '/debug/$'
      preLoaderRoute: typeof DebugSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/toplist': {
      id: '/_protected/toplist'
      path: '/toplist'
      fullPath: '/toplist'
      preLoaderRoute: typeof ProtectedToplistRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/table': {
      id: '/_protected/table'
      path: '/table'
      fullPath: '/table'
      preLoaderRoute: typeof ProtectedTableRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/tournaments/': {
      id: '/_protected/tournaments/'
      path: '/tournaments'
      fullPath: '/tournaments/'
      preLoaderRoute: typeof ProtectedTournamentsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/freegames/': {
      id: '/_protected/freegames/'
      path: '/freegames'
      fullPath: '/freegames/'
      preLoaderRoute: typeof ProtectedFreegamesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/account/': {
      id: '/_protected/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof ProtectedAccountIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/tournaments/$id/join': {
      id: '/tournaments/$id/join'
      path: '/tournaments/$id/join'
      fullPath: '/tournaments/$id/join'
      preLoaderRoute: typeof TournamentsIdJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/spectate': {
      id: '/games/$id/spectate'
      path: '/games/$id/spectate'
      fullPath: '/games/$id/spectate'
      preLoaderRoute: typeof GamesIdSpectateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/replay': {
      id: '/games/$id/replay'
      path: '/games/$id/replay'
      fullPath: '/games/$id/replay'
      preLoaderRoute: typeof GamesIdReplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/join': {
      id: '/games/$id/join'
      path: '/games/$id/join'
      fullPath: '/games/$id/join'
      preLoaderRoute: typeof GamesIdJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freegames/$id/spectate': {
      id: '/freegames/$id/spectate'
      path: '/freegames/$id/spectate'
      fullPath: '/freegames/$id/spectate'
      preLoaderRoute: typeof FreegamesIdSpectateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freegames/$id/join': {
      id: '/freegames/$id/join'
      path: '/freegames/$id/join'
      fullPath: '/freegames/$id/join'
      preLoaderRoute: typeof FreegamesIdJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/training/$snapshotId': {
      id: '/debug/training/$snapshotId'
      path: '/debug/training/$snapshotId'
      fullPath: '/debug/training/$snapshotId'
      preLoaderRoute: typeof DebugTrainingSnapshotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/newgame/$snapshotId': {
      id: '/debug/newgame/$snapshotId'
      path: '/debug/newgame/$snapshotId'
      fullPath: '/debug/newgame/$snapshotId'
      preLoaderRoute: typeof DebugNewgameSnapshotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/freegames/create': {
      id: '/_protected/freegames/create'
      path: '/freegames/create'
      fullPath: '/freegames/create'
      preLoaderRoute: typeof ProtectedFreegamesCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/account/subscriptions': {
      id: '/_protected/account/subscriptions'
      path: '/account/subscriptions'
      fullPath: '/account/subscriptions'
      preLoaderRoute: typeof ProtectedAccountSubscriptionsRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedTableRoute: typeof ProtectedTableRoute
  ProtectedToplistRoute: typeof ProtectedToplistRoute
  ProtectedAccountSubscriptionsRoute: typeof ProtectedAccountSubscriptionsRoute
  ProtectedFreegamesCreateRoute: typeof ProtectedFreegamesCreateRoute
  ProtectedAccountIndexRoute: typeof ProtectedAccountIndexRoute
  ProtectedFreegamesIndexRoute: typeof ProtectedFreegamesIndexRoute
  ProtectedTournamentsIndexRoute: typeof ProtectedTournamentsIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedTableRoute: ProtectedTableRoute,
  ProtectedToplistRoute: ProtectedToplistRoute,
  ProtectedAccountSubscriptionsRoute: ProtectedAccountSubscriptionsRoute,
  ProtectedFreegamesCreateRoute: ProtectedFreegamesCreateRoute,
  ProtectedAccountIndexRoute: ProtectedAccountIndexRoute,
  ProtectedFreegamesIndexRoute: ProtectedFreegamesIndexRoute,
  ProtectedTournamentsIndexRoute: ProtectedTournamentsIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface TrainingRouteChildren {
  TrainingCreateRoute: typeof TrainingCreateRoute
  TrainingIndexRoute: typeof TrainingIndexRoute
}

const TrainingRouteChildren: TrainingRouteChildren = {
  TrainingCreateRoute: TrainingCreateRoute,
  TrainingIndexRoute: TrainingIndexRoute,
}

const TrainingRouteWithChildren = TrainingRoute._addFileChildren(
  TrainingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ProtectedRoute: ProtectedRouteWithChildren,
  FreegameRoute: FreegameRoute,
  ResultsRoute: ResultsRoute,
  TournamentRoute: TournamentRoute,
  TrainingRoute: TrainingRouteWithChildren,
  AuthActionRoute: AuthActionRoute,
  DebugSplatRoute: DebugSplatRoute,
  DebugSnapshotIdRoute: DebugSnapshotIdRoute,
  SnapshotsIdRoute: SnapshotsIdRoute,
  UsersIdRoute: UsersIdRoute,
  DebugIndexRoute: DebugIndexRoute,
  GamesIndexRoute: GamesIndexRoute,
  SnapshotsIndexRoute: SnapshotsIndexRoute,
  DebugNewgameSnapshotIdRoute: DebugNewgameSnapshotIdRoute,
  DebugTrainingSnapshotIdRoute: DebugTrainingSnapshotIdRoute,
  FreegamesIdJoinRoute: FreegamesIdJoinRoute,
  FreegamesIdSpectateRoute: FreegamesIdSpectateRoute,
  GamesIdJoinRoute: GamesIdJoinRoute,
  GamesIdReplayRoute: GamesIdReplayRoute,
  GamesIdSpectateRoute: GamesIdSpectateRoute,
  TournamentsIdJoinRoute: TournamentsIdJoinRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
